import { constants } from '@tock/shared-app-constants';

export default constants([
  'ALL_PREFERENCE_OPTIONS_FETCH',
  'AVAILABILITY_CLEAR_SSR_INITIALIZATION',
  'AVAILABILITY_RESET_SSR_INITIALIZATION',
  'AVAILABILITY_SEARCH',
  'AVAILABILITY_SEARCH_CLEAR',
  'AVAILABILITY_SET_SCROLL_TO_TOP',
  'ACCOUNT_DELETE',
  'AUTHENTICATION_CLEARED',
  'AUTHENTICATION_METHODS',
  'AUTHENTICATION_RESPONSE',
  'AUTHENTICATION_FETCH_ROLES',
  'APPLY_GIFT_CARD',
  'BUSINESS_CALENDAR_DATES_FETCH',
  'BUSINESS_FETCH',
  'BUSINESS_CLEAR',
  'CANCEL_PURCHASE',
  'CALCULATE_PACKAGE_PRICE',
  'CALCULATE_PRICE',
  'CALENDAR_FETCH',
  'CALENDAR_FETCH_V2',
  'CALENDAR_AND_OFFERINGS_CLEAR',
  'CHANGE_ACTIVE_PARTNER_ROLE',
  'CHECKOUT_DETAILS_FETCH',
  'CHECKOUT_SET_STATUS',
  'CHASE_POINTS_BALANCE_UPDATE',
  'CHASE_POINTS_UPDATE',
  'CHASE_SET_PREV_LOGGED_IN_EMAIL',
  'CHASE_VALIDATE_TOCK_MATCH',
  'CLEAR_SEARCH_RESULTS',
  'CLOSE_LOYALTY_PROGRAM_LOGIN_MODAL',
  'COMMUNICATION_OPT_IN_SET_STATUS',
  'CONCIERGE_BOOK_VIA_EMAIL',
  'CONCIERGE_CANCEL_BOOK_VIA_EMAIL',
  'CONSUMER_PAGE_SEARCH_INIT',
  'CONSUMER_PAGE_SEARCH',
  'CONSUMER_PAGE_WIDGET_DATA_FETCH',
  'CONSUMER_PAGE_WIDGET_DATA_FETCH_V2',
  'CONFIG_FETCH',
  'CONFIRM_SELECTION_SET_DIALOG_VISIBILE',
  'CREATE_ACCOUNT',
  'DETECT_LOCATION',
  'DISCOUNT_CODE_CLEAR',
  'DISCOUNT_CODE_VERIFY',
  'ENABLE_REACT_NATIVE_MODE',
  'FETCH_ALL_ACHIEVEMENTS',
  'FETCH_BUSINESS_LOCK',
  'FETCH_CHASE_BIN_LIST',
  'GRAPHQL_ERROR_OCCURED',
  'GIFT_CARD_GET_BALANCE',
  'GIFT_CARD_CLEAR',
  'HISTORY_LOCATION_PUSH',
  'HISTORY_LOCATION_REPLACE',
  'HISTORY_LOCATION_BACK',
  'INITIALIZE_CHASE_SESSION',
  'LOCK_CLEAR',
  'LOCK_CLEAR_PACKAGE',
  'LOCK_FETCH_ALL',
  'LOCK_FETCH_ALL_BY_IDS',
  'LOCK_SELECT_NEXT_IN_SEQUENCE',
  'LOCK_ADD_COMPLETED_PURCHASE_ID',
  'LOCK_SESSION_RELOCK_TICKETS',
  'LOCK_TICKETS',
  'LOCK_PACKAGE',
  'LOYALTY_PROGRAM_CLEAR',
  'LOYALTY_PROGRAM_CLEAR_LOGIN',
  'LOYALTY_PROGRAM_FETCH_BALANCE',
  'LOYALTY_PROGRAM_LOGIN',
  'LOYALTY_PROGRAM_POINTS',
  'OFFERINGS_FETCH',
  'OFFERING_FETCH',
  'MENU_CLOSE',
  'MENU_TOGGLE',
  'METRO_AREA_CLOSEST',
  'METRO_AREA_SELECTED',
  'NAV_SEARCH_TOGGLE',
  'NAVIGATION_SET',
  'NAVIGATION_INCREMENTAL_UPDATE',
  'OPEN_LOYALTY_PROGRAM_LOGIN_MODAL',
  'PACKAGE_CONFIRM_CHOICES',
  'PACKAGE_EDIT_CHOICES',
  'PACKAGE_SELECT_PACKAGE',
  'PACKAGE_SELECT_SIZE',
  'PACKAGE_SELECT_DATE',
  'PACKAGE_SELECT_TIME',
  'PACKAGE_SELECT_OPTIONS',
  'PACKAGE_CLEAR',
  'PARTNER_FETCH_ALL_RESERVATIONS',
  'PARTNER_ROLE_ADD',
  'PARTNER_ROLE_FETCH_ALL',
  'PARTNER_ROLE_FETCH_ALL_DONE',
  'PARTNER_ROLE_FETCH_ALL_STARTING',
  'PARTNER_ROLE_FETCH_ALL_FAIL',
  'PARTNER_ROLE_UPDATE',
  'PATRON_FETCH_LEGACY_TRANSFERS',
  'PATRON_FETCH_ACHIEVEMENTS',
  'PATRON_FETCH_QUIZ_QUESTIONS',
  'PATRON_FETCH_QUIZ_RESULTS',
  'PATRON_FETCH_QUIZ_ANSWERS',
  'PATRON_PROFILE_FETCH_PROFILE',
  'PATRON_FETCH_PURCHASE_HISTORY',
  'PATRON_FETCH_PURCHASE_SUMMARIES',
  'PATRON_FETCH_PURCHASES_AROUND_TIME',
  'PATRON_FETCH_PROFILE_STATS',
  'PATRON_ADD_TO_WISHLIST',
  'PATRON_FETCH_WISHLIST',
  'PATRON_OPEN_EDIT_PROFILE',
  'PATRON_CLOSE_EDIT_PROFILE',
  'PATRON_OPEN_QUIZ_MODAL',
  'PATRON_CLOSE_QUIZ_MODAL',
  'PATRON_SET_PROFILE',
  'PATRON_PLAYLIST_ADD_ITEM',
  'PATRON_PLAYLISTS_FETCH',
  'PATRON_PLAYLIST_ITEM_DELETE',
  'PATRON_PLAYLIST_UPSERT',
  'PATRON_PROFILE_SET_PROFILE',
  'PATRON_PROFILE_SET_IMAGE',
  'PATRON_PUT_QUIZ_RESPONSES',
  'PATRON_LOCATION_HISTORY_UPDATED',
  'PAYMENT_ERROR',
  'RESCHEDULE',
  'RESCHEDULE_PAID',
  'RESCHEDULE_CLEAR',
  'RESCHEDULE_PURCHASE_UPDATE',
  'TRANSFER_INITIATE',
  'TRANSFER_CANCEL',
  'TRANSFER_CLEAR',
  'PATRON_AUTH_TYPE_GET',
  'PATRON_ACTIVE_EMAIL_CHANGE',
  'PATRON_EMAIL_CHANGE',
  'PATRON_EMAIL_CHANGE_CANCEL',
  'PATRON_INITIATE_EMAIL_CHANGE',
  'PATRON_IMPRESSION',
  'PRIVATE_DINING_REQUEST',
  'PAST_PURCHASE_CLEAR',
  'PAST_PURCHASE_TICKET_TYPE_DETAILS_CLEAR',
  'PAST_PURCHASE_FETCH',
  'PLAYLIST_FETCH',
  'PURCHASE_CLEAR',
  'PURCHASE',
  'PURCHASE_PACKAGE',
  'PURCHASE_SET_KEY_VALUES',
  'REMOVE_GIFT_CARD',
  'RESTORE_AUTH',
  'RWG_TOKEN_CONVERSION',
  'SEARCH_SET',
  'SELECTION_SET',
  'SELECTION_UPDATE',
  'SET_COLOR_THEME',
  'SET_COOKIE_CONSENT_STATE',
  'SET_EXPERIMENT_VARIANT',
  'SET_FONT_THEME',
  'SET_GOOGLE_MAPS_LOADED',
  'SET_GOOGLE_MAPS_LOAD_ERROR',
  'SET_SETTINGS',
  'SET_BUSINESS_SCOPE',
  'SET_CHASE_PRODUCT_CODE',
  'SET_QUERIES',
  'SCROLL_SET',
  'SHOW_INFO_TOAST',
  'SHOW_ERROR_TOAST',
  'CLEAR_TOAST',
  'SUPPLEMENT_GROUPS_SET_STATES',
  'SUPPLEMENT_GROUPS_PACKAGE_SET_STATES',
  'SURVEY_FETCH',
  'SURVEY_SUBMIT',
  'SYNDICATE_CLEAR',
  'SYNDICATE_SET',
  'TICKET_TYPE_COMMUNICATIONS_FETCH',
  'TOCK_GIFT_CARD_PURCHASE',
  'TOCK_GIFT_CARD_PURCHASE_HISTORY',
  'TOCK_GIFT_CARD_CLEAR',
  'TOCK_GIFT_CARD_REDEEM',
  'TOCK_GIFT_CARD_BALANCE',
  'TOCK_GIFT_CARD_ADDED',
  'TOCK_GIFT_CARD_REMOVED',
  'TRANSFER_PURCHASE_ORDER_FETCH',
  'TRANSFER_IS_GIFT_FLOW_UPDATE',
  'TRANSFER_PRICE_UPDATE',
  'TRANSFER_PURCHASE_UPDATE',
  'TRANSFER_TO_EMAIL_UPDATE',
  'TRANSFER_VERIFY_GET_PURCHASE',
  'UNLOCK_TICKETS',
  'VALIDATE_PHONE_REQUEST',
  'WAITLIST_SET_DIALOG_VISIBILE',
  'UPDATE_DELIVERY_ADDRESS',
  'UPDATE_DINER',
  'UPDATE_LAST_GUEST',
  'UPSERT_POST_VISIT_FEEDBACK',
  // WWW
  'DISCOVER_AUTOCOMPLETE_NAV_SUGGESTIONS',
  'DISCOVER_FETCH_ALL',
  'DISCOVER_SEARCH',
  'DISCOVER_SUGGEST',
  'WALK_IN_WAITLIST_ADD',
  'WALK_IN_WAITLIST_CANCEL',
  'WALK_IN_WAITLIST_RESTORE',
  'WALK_IN_WAITLIST_PARTY_DETAIL',
  'WALK_IN_WAITLIST_PARTY_STATUS',
  'WALK_IN_WAITLIST_SIZE',
  'WIDGET_BUILDER_FETCH_TICKET_TYPES',
  'WIDGET_BUILDER_TOKEN',
  'NULL',
  // SHOP
  'UPDATE_SHIPPING_ADDRESS',
  'UPDATE_BILLING_ADDRESS',
  'UPDATE_PAYMENT_CARD',
  'UPDATE_BIRTH_DATE',
  'UPDATE_GIFT_NOTE',
  'FETCH_SHOP_ITEM_AVAILABILITY',
  'SELECT_SHOP_ITEM',
  'SELECT_SHOP_BUSINESS',
  'SHOP_ITEM_SEARCH',
  'SHOP_ITEM_LOAD_MORE',
  'SHOP_BRAND_ITEM_SEARCH',
  'SHOP_BRAND_ITEM_LOAD_MORE',
  'CLEAR_SHOP_CHECKOUT_INFO',
  // Acts on the shopCart cart representation
  'UPDATE_CART_ITEM_QUANITY',
  'ADD_CART_VALIDATION_ERROR',
  'SET_CART_CONTENTS_EXACTLY',
  'COMPLETE_CART_BRAND_GROUPS',
  // Acts on the shopSelection "really checking-this-out now"
  'SELECT_BRAND_GROUP_SHIPPING_METHOD',
  'SHOP_ITEM_GET_REFINEMENTS',
  'ADD_ACTIVE_WORKFLOW',
  'CLEAR_ALL_CHECKOUT_RESPONSES',
  'RESOLVE_ACTIVE_WORKFLOW',
  'UPDATE_SHOP_BUSINESS_SHIPPING_SELECTION',
  // Shop price calculation
  'ADD_PRICE_CALCULATION_RESPONSE',
  'REMOVE_PRICE_CALCULATION_RESPONSE',
  'ADD_PRICE_CALCULATION_LOADING',
  'REMOVE_PRICE_CALCULATION_LOADING',
  'SET_ACTIVE_CHECKOUT_BUSINESS_IDS',
  'CLEAR_ACTIVE_CHECKOUT_BUSINESS_IDS',
  'UPDATE_SHIPPING_STATE',
]);
